export default __webpack_public_path__ + "static/media/10.84426a34.png";